/**************************************************
 * Nombre:       IconoTexto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";

const IconoTexto = ({Icono, texto, color = '#ffffff80'}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{color: color}}
            spacing={3}
        >

            <Grid container size={{xs: 1, sm: 1, md: 1}} sx={{justifyContent: 'flex-start', mt: 0}}>
                <Icono sx={{width: 20, height: 20}}/>
            </Grid>

            <Grid container size={{xs: 10, sm: 10, md: 10}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 14, fontWeight: 300}}>{texto}</Typography>
            </Grid>

        </Grid>
    )

}
export default IconoTexto